{
    "SkZvhzbOXuuO3dbB78NKY": {
        "position": {
            "x": 13,
            "y": 21,
            "z": 1
        },
        "templateKey": "jobs/pirates/hammer",
        "jobKey": "pirates/hammer",
        "affiliation": "bad",
        "key": "SkZvhzbOXuuO3dbB78NKY",
        "previousMultiselect": {},
        "maxhealth": "30",
        "imageKey": "skeleton"
    },
    "u-NJO-lfTt-uk9kTBq4mH": {
        "position": {
            "x": 15,
            "y": 16,
            "z": 1
        },
        "templateKey": "jobs/pirates/sword",
        "jobKey": "pirates/sword",
        "affiliation": "bad",
        "key": "u-NJO-lfTt-uk9kTBq4mH",
        "previousMultiselect": {},
        "maxhealth": "30",
        "imageKey": "skeleton"
    },
    "dO08V_X8ydH0Ep6oQD4Av": {
        "position": {
            "x": 13,
            "y": 16,
            "z": 1
        },
        "templateKey": "jobs/pirates/sword",
        "jobKey": "pirates/sword",
        "affiliation": "bad",
        "key": "dO08V_X8ydH0Ep6oQD4Av",
        "previousMultiselect": {},
        "maxhealth": "30",
        "imageKey": "skeleton"
    },
    "F83lwV1TuQ64zVWdvHgG8": {
        "position": {
            "x": 16,
            "y": 15,
            "z": 1
        },
        "templateKey": "jobs/pirates/gun",
        "jobKey": "pirates/gun",
        "affiliation": "bad",
        "key": "F83lwV1TuQ64zVWdvHgG8",
        "previousMultiselect": {},
        "imageKey": "skeleton"
    },
    "TcYq3HmyKngn-ZpI2aEur": {
        "position": {
            "x": 14,
            "y": 14,
            "z": 1
        },
        "templateKey": "jobs/pirates/gun",
        "jobKey": "pirates/gun",
        "affiliation": "bad",
        "key": "TcYq3HmyKngn-ZpI2aEur",
        "previousMultiselect": {},
        "imageKey": "skeleton"
    },
    "LnpagKE1-9iKfAu5_Wl26": {
        "position": {
            "x": 15,
            "y": 19,
            "z": 1
        },
        "templateKey": "jobs/pirates/hammer",
        "jobKey": "pirates/hammer",
        "affiliation": "bad",
        "key": "LnpagKE1-9iKfAu5_Wl26",
        "previousMultiselect": {},
        "maxhealth": "30",
        "imageKey": "skeleton"
    },
    "GmzRGIPq8RqaNs9iDQIZ2": {
        "position": {
            "x": 16,
            "y": 8,
            "z": 1
        },
        "templateKey": "jobs/pirates/gun",
        "jobKey": "pirates/gun",
        "affiliation": "bad",
        "key": "GmzRGIPq8RqaNs9iDQIZ2",
        "previousMultiselect": {},
        "imageKey": "skeleton"
    },
    "sV9aZwebE1q54ziTbt_3Z": {
        "position": {
            "x": 13,
            "y": 7,
            "z": 1
        },
        "templateKey": "jobs/pirates/dagger",
        "jobKey": "pirates/dagger",
        "affiliation": "bad",
        "key": "sV9aZwebE1q54ziTbt_3Z",
        "previousMultiselect": {},
        "imageKey": "skeleton"
    },
    "6XOb29YCbblEj2Al3lf29": {
        "position": {
            "x": 17,
            "y": 10,
            "z": 1
        },
        "templateKey": "jobs/pirates/sword",
        "jobKey": "pirates/sword",
        "affiliation": "bad",
        "key": "6XOb29YCbblEj2Al3lf29",
        "previousMultiselect": {},
        "maxhealth": "30",
        "imageKey": "skeleton"
    },
    "m57-jWOGNDF-mJF6xqs0n": {
        "position": {
            "x": 14,
            "y": 9,
            "z": 1
        },
        "templateKey": "jobs/pirates/hammerknight",
        "jobKey": "pirates/hammerknight",
        "affiliation": "bad",
        "key": "m57-jWOGNDF-mJF6xqs0n",
        "previousMultiselect": {},
        "imageKey": "skeleton"
    }
}
